import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "skpBaru";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const skpBaruCreate =
  "Kepegawaian/SkpBaru/create/";
export const skpBaruUpdate =
  "Kepegawaian/SkpBaru/update/";
export const skpBaruList = "Kepegawaian/SkpBaru/list/";
export const masterWorkUnit = "Master/List/workUnit/";
// export const listAtasan = "Kepegawaian/SkpBaru/listAtasan/";
export const exportExcel = "Kepegawaian/SkpBaru/exportExcel/";
export const employeeList = "Kepegawaian/SkpBaru/listEmployee/";
export const individualcriterialist = "Kepegawaian/SkpBaru/get_individualcritereia/";
export const skppernipCreate = "Kepegawaian/SkpBaru/createpernip/";
export const skpBaruDetail = "Kepegawaian/SkpBaru/detail/";
export const skpBaruDelete = "Kepegawaian/SkpBaru/delete/";
export const checkSkp = "Kepegawaian/SkpBaru/checkskp/";
export const previewUpload = "Kepegawaian/SkpBaru/previewUploadExcel/";
export const getposition = "Kepegawaian/SkpBaru/get_position/";
export const checkverification = "Kepegawaian/SkpBaru/check_verification/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};

export const checkExistingEmployeeSkp = "Kepegawaian/SkpBaru/checkExistingEmployeeSkp/";
